// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16QMm","comment":"styles_comment__bYSUS"};